import axios from 'axios';

import { responseEntityMapper, responseListMapper } from '@qwealth/qcore';
import { QContext, REACT_APP_QWEALTH_API } from '@qwealth/qdata';

import { CreateTagData, TagData } from 'data/models/TaskTags';

const apiUrl = REACT_APP_QWEALTH_API?.replace('/v1', '/v3');
const headers = {
  Authorization: `Bearer ${QContext.getIdToken()}`,
  'user-uuid': QContext.getUserUuid(),
};

export const getTaskTagsApi = async (partnerId: number): Promise<TagData[]> =>
  axios.get(`${apiUrl}/task/taskTag`, { headers, params: { partnerId: partnerId } }).then(response => responseListMapper<TagData>(response));

export const postTaskTagsApi = async (tag: CreateTagData): Promise<TagData> =>
  axios.post(`${apiUrl}/task/taskTag`, tag, { headers }).then(response => responseEntityMapper<TagData>(response));

export const deleteTaskTagsApi = async (tagId: number) => axios.delete(`${apiUrl}/task/taskTag/${tagId}`, { headers });
